import React from 'react'
import Link from 'gatsby-link'
import { renderStylesToNodeStream } from 'emotion-server'
import PricingCard from '../components/PricingCards/PricingCard'
import '../components/PricingCards/PricingCards.css'

const IndexPage = () => (
  <div
    className="mt-3 pricingdiv"
    style={{
      maxWidth: '80%',
      margin: '20px auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: "center'",
    }}
  >
    <PricingCard title="KIDS" digital="10" printed="20" full="30" />
    <PricingCard title="BULLS" digital="15" printed="25" full="50" />
    <PricingCard title="GROUP OR MISC" digital="10" printed="15" />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js